import { BREAKPOINTS } from './breakponts';

export default {
  MuiFormLabel: {
    root: {
      letterSpacing: 'unset'
    }
  },
  MuiTab: {
    root: {
      minWidth: 160,
      padding: '6px 24px',
      '& *': {
        fontFamily: 'Open Sans'
      }
    },
  },
  MuiMenuItem: {
    root: {
      minHeight: 46,
      [`@media (min-width: ${BREAKPOINTS.sm}px)`]: {
        minHeight: 46,
      },
    }
  },
  MuiRadio: {
    root: {
      //Label uses Typography-body-1
      '& + span': {
        fontSize: 14
      }
    }
  },
  MuiSelect: {
    select: {
      '&:focus': {
        backgroundColor: 'transparent'
      }
    }
  },
};